module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0109.jpg?v=9987c2f3";